import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getApiUrl } from '../services/fetch'
import Token from '../utils/Token'

const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl(),
    prepareHeaders: headers => {
      const token = Token.get()
      if (token) headers.set('authorization', `Bearer ${token}`)
      return headers
    },
  }),
  tagTypes: ['EVENT_USER', 'FORM', 'Company', 'User'],
  endpoints: builder => ({
    getEvent: builder.query({
      query: ({ domainId, eventId }) => ({
        url: `/v2/domains/${domainId}/events/${eventId}`,
        method: 'GET',
      }),
      transformResponse: response => response.data,
    }),
    getTranslations: builder.query({
      query: ({ domainId }) => ({
        url: `/v2/domains/${domainId}/translations`,
        method: 'GET',
      }),
      transformResponse: response => response.data,
    }),
    getContext: builder.query({
      query: context => `/context/${context}`,
      transformResponse: response => response.data,
    }),
    // Le badge participant est désormais rendu par la v2 (badgeTemplates, service apix) —
    // voir src/api/v2/badge.js (useRenderUserBadgeMutation / useGetRenderUserBadgeQuery).
  }),
})

export const { useGetEventQuery, useGetContextQuery, useGetTranslationsQuery } = api
export const { resetApiState } = api.util

export default api
